import React, { Component } from 'react';
import firebase from './Firebase';
import history from '../history';
import axios from 'axios';

// Class-based component that checks every minute whether the current user
// last signed in more than 31 days ago. If so, the user is signed out
// and redirected to the login page.
class SessionTimeout extends Component {
  componentDidMount() {
    // Run an immediate check and then every minute thereafter.
    this.checkSession();
    this.interval = setInterval(this.checkSession, 60 * 1000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  checkSession = async () => {
    const user = firebase.auth().currentUser;
    console.log(user, "USER METADATA");
    if (!user) {
      return;
    }

    console.log(user, "USER METADATA");
    const lastSignIn = new Date(user.metadata.lastSignInTime).getTime();
    console.log(lastSignIn, Date.now(), "LAST SIGN IN");

    // TEST 123456
    const THIRTY_ONE_DAYS_MS = 31 * 24 * 60 * 60 * 1000;
    // Test 1min ago for testing

    if (Date.now() - lastSignIn > THIRTY_ONE_DAYS_MS) {
      // Log this admin logout to Discord before signing out
      try {
        const token = await user.getIdToken();
        await axios.post('/api/admin/logSessionTimeout', {
          lastSignIn: new Date(user.metadata.lastSignInTime).toISOString(),
          daysSinceLastSignIn: Math.floor((Date.now() - lastSignIn) / (24 * 60 * 60 * 1000)),
          userEmail: user.email,
          userId: user.uid
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
      } catch (error) {
        console.error('Failed to log session timeout:', error);
      }

      firebase
        .auth()
        .signOut()
        .then(() => {
          history.push('/login');
        })
        .catch(() => {
          // Ignore errors – user will be considered signed out anyway.
        });
    }
  };

  render() {
    return null; // Nothing visual; solely side-effects.
  }
}

export default SessionTimeout; 